import { useEffect, useState } from 'react'
import axios from 'axios';
import Main from '../../../component/Main';
import WholeLoading from '../../../component/common/loading/WholeLoading';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect'
import SearchBtn from '../../../component/common/button/SearchBtn';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid';
import UserDetail from './UserDetail';
import EmogSearchLayer from './EmogSearch_layer';
import WithdrawalUserModal from '../../member/mypage/WithdrawalUser_modal';
import { useShallow } from 'zustand/shallow';
import useModalStore from '../../../zustand/store/useModalStore';
import useConfirm from '../../../hooks/useConfirm';
import { useIs17Inch } from '../../../hooks/useBreakPoint';

import JoinUser from './JoinUser';

const UserMng = () => {

    // localStorage에서 원하는 계정 정보 map으로 가져오기
    const keys = ['id', 'useremcd', 'userAuth'];
    const localValues = Object.fromEntries( keys.map(key => [key, localStorage.getItem(key)]) );

    const [isWholeLoading, setIsWholeLoading] = useState(false);

    const [searchParams, setSearchParams] = useState({
        userauth: localValues.userAuth,
        useremcd: localValues.useremcd,
        searchLoginFromDate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchLoginToDate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchGrdc: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("emoggrdc2") : '',
        searchLoca: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("emogloca") : '',
        searchEmog: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("emogdesc") : '',
        searchAccess: '',
        searchUseramYn: 'N',
        searchNameandid: '',
        searchLoginAllDateYn: 'Y',
        searchEtc: '',
        validationCheckList: []
    });
    
    const searchParamsAdditional = {
    };

    // cell onClick state
    const [selectUser, setSelectUser] = useState({
        useridno: '',
        username: '',
    });

    // 기관 선택 state
    const [selectEmog, setSelectEmog] = useState({
        emogcode: '',
        emogdesc: '',
    });
    
    // 회원탈퇴 state
    const [withdrawalUserOpen, setWithdrawalUserOpen] = useState(false);
    const [withdrawalUser, setWithdrawalUser] = useState({
        username: '',
        useridno: '',
        userupid: localValues.id,
        deletereason: '01',
        deletemsg: '',
    })
    
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newParams = {
            ...searchParams,
            [name]: type === 'checkbox' ? (checked ? 'Y' : '') : value
        };
        setSearchParams(newParams);
        const withdrawalNewParams = {
            ...withdrawalUser,
            [name]: value
        };
        setWithdrawalUser(withdrawalNewParams);
    };

    const dataHead = ['NO', '사용자등급', '지역', '기관명', '사용자명', '사용자ID', '가입일자', '접속횟수', '관리자 권한', '승인여부']; 
    const dataColumn = ['SEQ', 'USERAUTH', 'EMOGLOCA', 'EMOGDESC', 'USERNAME', 'USERIDNO', 'USERDATE', 'USERACCN', 'USERADMN', 'USERAMYN'];
    const apiCall = '/commonapi/selectMngUserList.do';
    const apiCntCall = '';
    const excelFileName = '사용자 목록';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead, 
        dataColumn: dataColumn, 
        apiCall: apiCall, 
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false,
        loadingHeight: '10rem'
    })
    
    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    // 데이터 수정 후 re search
    const [reSearch, setReSearch] = useState(false);
    
    // cell click 사용 시 넘겨줄 props
    const [detailData, setDetailData] = useState([]);
    const [selectRow, setSelectRow] = useState();
    const selectCellParams = ['USERIDNO', 'USERNAME'];

    const handleOnClick = (dataList, index, selectCellParams, key) => {
        setIsWholeLoading(true);
        setSelectUser({
            useridno: dataList[index][selectCellParams[0]],
            username: dataList[index][selectCellParams[1]]
        });
        setWithdrawalUser(prev => ({
            ...prev,
            useridno: dataList[index][selectCellParams[0]],
            username: dataList[index][selectCellParams[1]]
        }));
        setSelectRow(key);
    };

    // 사용자 승인/미승인, 아이핀 초기화 시 상세 정보 re road
    const updateUserRefresh = (useridno) => {
        setSelectUser(prev => ({
            ...prev,
            useridno: useridno,
        }));
    }

    // 선택된 사용자 상세정보
    const userDetailData = async () => {
        try {
            const response = await axios.get('/commonapi/selectMngUserDetail.do',
                { params: selectUser }
            );
            setDetailData(response.data);
            setIsWholeLoading(false);
            setUpdateEmog(false);
        } catch (error) {
            console.error('상세정보 로딩 중 오류 발생:', error);
        }
    };

    useEffect(() => {
        if(selectUser.useridno !== '') {
            userDetailData();
        }
    }, [selectUser]);

    // 기간 선택 시 시작 날짜 세팅
    const searchDayDisabled = searchParams?.searchLoginAllDateYn === 'Y' ? 'disabled' : '';
    const setSearchDay = (value) => {
        const endDate = searchParams.searchLoginToDate
        const [year, month, day] = endDate.split("-");
        const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

        const setDay = new Date(date);
        setDay.setDate(setDay.getDate() - value);

        const startDate = setDay.getFullYear()+'-'+(setDay.getMonth()+1 < 10 ? '0'+(setDay.getMonth()+1) : setDay.getMonth()+1)+'-'+ ( setDay.getDate() < 10 ? '0'+(setDay.getDate()) : setDay.getDate() ) ;
        setSearchParams(prev => ({
            ...prev,
            searchLoginFromDate: startDate
        }))
    }

    // 사용자 등록
    const [joinUserOpen, setJoinUserOpen] = useState(false);

    // 기관 검색 modal
    const [emogSearchLayerOpen, setEmogSearchLayerOpen] = useModalStore(useShallow((state) => [state.emogSearchLayerOpen, state.setEmogSearchLayerOpen]));
    const [updateEmog, setUpdateEmog] = useState(false);

    // 화면을 떠나면 기관검색 창을 닫는다. 열림 상태가 store 에 남아 있어, 닫지 않으면 다시 들어왔을 때 열린 채로 나온다
    // (기관검색을 여는 순간 세션이 만료돼 로그인 화면으로 나간 경우)
    useEffect(() => () => setEmogSearchLayerOpen(false), [setEmogSearchLayerOpen]);

    const showNotiModal = useModalStore(state => state.showNotiModal);
    const confirm = useConfirm();

    // 기관을 고르면 저장 전에 서버가 미리 확인한다. 옮길 수 없는 기관이면 안내하고,
    // 관리 범위 밖으로 옮기게 되면(저장 뒤에는 이 사용자를 다시 고칠 수 없다) 한 번 더 묻는다
    const confirmEmogSelect = async (emog) => {
        if (selectUser.useridno === '' || !emog) return true;
        try {
            const response = await axios.post('/commonapi/checkUserOrgChange.do', {
                useridno: selectUser.useridno,
                useremcd: emog.emogcode,
            });
            const resultMap = response.data.resultMap;
            if (!resultMap.result) {
                showNotiModal(resultMap.resultMessage);
                return false;
            }
            return resultMap.confirmMessage ? await confirm(resultMap.confirmMessage) : true;
        } catch (error) {
            console.error('기관 변경 확인 중 오류 발생:', error);
            return false;
        }
    };

    const is17Inch = useIs17Inch();
    
    const activeEnter = (e) => {
        if(e.key === 'Enter') {
            setReSearch(true);
        }
    }

    return (
        <Main>
            {isWholeLoading ? <WholeLoading /> : ''}
            {/* 기관검색 modal */}
            <EmogSearchLayer
                setSelectEmog={setSelectEmog}
                setUpdateEmog={setUpdateEmog}
                beforeSelect={confirmEmogSelect}
                emogSearchLayerOpen={emogSearchLayerOpen}
                setEmogSearchLayerOpen={setEmogSearchLayerOpen}
            />
            {/* 사용자 등록 modal - 향후 기능추가 요청 있을 시 사용(미완성) */}
            <JoinUser 
                joinUserOpen={joinUserOpen}
                setJoinUserOpen={setJoinUserOpen}
            />
                <div className='h-full flex flex-col min-h-0 flex-grow'>
                    <div className='com-search'>
                        <table>
                            <colgroup>
                                <col width='12%' />
                                <col width='20%' />
                                <col width='12%' />
                                <col width='20%' />
                                <col width='12%' />
                                <col width='15%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <NewCommonSelect 
                                        hospitalTF={false}
                                        searchParams={searchParams}
                                        handleInputChange={handleInputChange}
                                    />
                                    <th>기관명</th>
                                    <td>
                                        <input
                                            type='text'
                                            className='input_style'
                                            name='searchEmog'
                                            defaultValue={localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("emogdesc") : ''}
                                            disabled={localStorage.getItem("userAuth") === 'J003'}
                                            onChange={handleInputChange}
                                            onKeyDown={(e) => activeEnter(e)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>접근권한선택</th>
                                    <td>
                                        <select className='w-full' name='searchAccess' defaultValue={searchParams.searchAccess} onChange={handleInputChange}>
                                            <option value=''>==권한선택==</option>
                                            <option value='02'>표준등록체계</option>
                                            <option value='04'>외상등록체계</option>
                                        </select>
                                    </td>
                                    <th>승인여부</th>
                                    <td>
                                        <select className='w-full' name='searchUseramYn' defaultValue={searchParams.searchUseramYn} onChange={handleInputChange}>
                                            <option value=''>==전체==</option>
                                            <option value='Y'>승인</option>
                                            <option value='N'>미승인</option>
                                        </select>
                                    </td>
                                    <th>사용자명 또는 ID</th>
                                    <td>
                                        <input type='text' className='input_style' name='searchNameandid' onChange={handleInputChange} onKeyDown={(e) => activeEnter(e)}/>
                                    </td>
                                </tr>
                                <tr>
                                    <th>최종로그인일자</th>
                                    <td colSpan='3'>
                                        <div className='flex gap-2 items-center'>
                                            <input
                                                type='date'
                                                name='searchLoginFromDate'
                                                value={searchParams.searchLoginFromDate}
                                                onChange={handleInputChange}
                                                disabled={searchParams.searchLoginAllDateYn === 'Y'}
                                            />
                                            ~
                                            <input
                                                type='date'
                                                name='searchLoginToDate'
                                                value={searchParams.searchLoginToDate}
                                                min={searchParams.searchLoginFromDate}
                                                onChange={handleInputChange}
                                                disabled={searchParams.searchLoginAllDateYn === 'Y'}
                                            />
                                            <label>
                                                <input type='checkbox' name='searchLoginAllDateYn' onChange={handleInputChange} defaultChecked={searchParams.searchLoginAllDateYn === 'Y'} />전체
                                            </label>
                                            <div className='flex gap-1'>
                                                <button value='7' className='pw_btn' disabled={searchDayDisabled} onClick={() => setSearchDay(7)}>1주일</button>
                                                <button value='30' className='pw_btn' disabled={searchDayDisabled} onClick={() => setSearchDay(30)}>1개월</button>
                                                <button value='180' className='pw_btn' disabled={searchDayDisabled} onClick={() => setSearchDay(180)}>6개월</button>
                                            </div>
                                        </div>
                                    </td>
                                    <th>비고</th>
                                    <td>
                                        <input type='text' className='input_style' name='searchEtc' onChange={handleInputChange} onKeyDown={(e) => activeEnter(e)}/>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>	
                    <SearchBtn
                        propsInfo={propsInfo}
                        state={state}
                        setState={setState}
                        searchParams={searchParams}
                        searchParamsAdditional={searchParamsAdditional}
                        pageInfo={pageInfo}
                        setPageInfo={setPageInfo}
                        reSearch={reSearch}
                        setReSearch={setReSearch}
                    />
                    <div className='flex flex-col min-h-0 flex-grow overflow-auto pr-1'>
                        <div className={`flex flex-col min-h-10 ${!is17Inch && 'hp-40'} ${state.isLoading ? 'flex-grow' : ''}`}>
                            <div className='mb-2 bold'>■ 사용자 목록</div>
                            <div className='flex overflow-hidden flex-grow mng_data_grid'>
                                <NewDataGrid
                                    propsInfo={propsInfo}
                                    state={state}
                                    pageInfo={pageInfo}
                                    setPageInfo={setPageInfo}
                                    selectCellParams={selectCellParams}
                                    handleOnClick={handleOnClick}
                                    selectRow={selectRow}
                                />
                            </div>
                        </div>
                        <div className='flex flex-col min-h-0 flex-grow'>
                            <div className='mb-2 bold'>■ 사용자 상세정보</div>
                            <UserDetail
                                detailData={detailData}
                                selectUser={selectUser}
                                setWithdrawalUserOpen={setWithdrawalUserOpen}
                                setReSearch={setReSearch}
                                updateUserRefresh={updateUserRefresh}
                                emogSearchLayerOpen={emogSearchLayerOpen}
                                setEmogSearchLayerOpen={setEmogSearchLayerOpen}
                                selectEmog={selectEmog}
                                setSelectEmog={setSelectEmog}
                                updateEmog={updateEmog}
                                setUpdateEmog={setUpdateEmog}
                                setJoinUserOpen={setJoinUserOpen}
                            />
                        </div>
                    </div>
                </div>
            {/* 회원탈퇴 modal */}
            <div className={`modal_container ${withdrawalUserOpen ? 'visible' : 'invisible'}`}>
                <div className='mypage_contents'>
                    <WithdrawalUserModal 
                        withdrawalUser={withdrawalUser}
                        setWithdrawalUser={setWithdrawalUser}
                        withdrawalUserOpen={withdrawalUserOpen}
                        setWithdrawalUserOpen={setWithdrawalUserOpen}
                        handleInputChange={handleInputChange}
                        setReSearch={setReSearch}
                    />
                </div>
            </div>
        </Main>
    )
}

export default UserMng